import React from 'react';
import PropTypes from 'prop-types';

import * as Intercom from 'intercom';
import { supportUrl } from 'Config.es6';

import { TextLink, Button } from '@contentful/ui-component-library';

class ContactUsButton extends React.Component {
  static propTypes = {
    noIcon: PropTypes.bool,
    buttonType: PropTypes.oneOf(['link', 'button']),
    children: PropTypes.node
  };

  contactUs = () => {
    // Open intercom if it's possible, otherwise go to support page.
    if (Intercom.isEnabled() && Intercom.isLoaded()) {
      Intercom.open();
    } else {
      window.open(supportUrl);
    }
  };

  render() {
    const { noIcon, buttonType, children, ...otherProps } = this.props;

    const isLink = !buttonType || buttonType === 'link';
    const ButtonComponent = isLink ? TextLink : Button;

    const props = {
      onClick: this.contactUs,
      ...otherProps
    };

    if (!noIcon) {
      props.icon = 'ChatBubble';
    }

    return <ButtonComponent {...props}>{children || `Get in touch with us`}</ButtonComponent>;
  }
}

export default ContactUsButton;



// WEBPACK FOOTER //
// ./src/javascripts/ui/Components/ContactUsButton.es6.js